import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-20 bg-white px-6" data-id="element-9">
      <div className="container mx-auto max-w-5xl" data-id="element-10">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-wine-dark mb-16" data-id="element-11">
          ¿Es esto para nosotros?
        </h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-12">
          {/* Es para ti */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-green-50/50 border border-green-100 p-8 rounded-2xl" data-id="element-13">
            <h3 className="text-2xl font-bold text-green-800 mb-6 flex items-center gap-3" data-id="element-14">
              <span className="bg-green-100 p-2 rounded-full" data-id="element-15">
                <Check className="w-6 h-6 text-green-600" data-id="element-16" />
              </span>
              Es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-17">
              {['Se quieren, pero se traban para iniciar', 'Te paraliza el miedo al rechazo', 'Quieren romance real, no actuación'].map((item, i) => <li key={i} className="flex items-start gap-3 text-green-900/80 text-lg" data-id="element-18">
                  <Check className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" data-id="element-19" />
                  {item}
                </li>)}
            </ul>
          </motion.div>

          {/* No es para ti */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-red-50/50 border border-red-100 p-8 rounded-2xl" data-id="element-20">
            <h3 className="text-2xl font-bold text-red-800 mb-6 flex items-center gap-3" data-id="element-21">
              <span className="bg-red-100 p-2 rounded-full" data-id="element-22">
                <X className="w-6 h-6 text-red-600" data-id="element-23" />
              </span>
              No es para ti si:
            </h3>
            <ul className="space-y-4" data-id="element-24">
              {['Buscas manipular o presionar', 'Hay coerción, miedo o castigo cuando alguien dice “no”', 'Buscas una solución mágica sin poner de tu parte'].map((item, i) => <li key={i} className="flex items-start gap-3 text-red-900/80 text-lg" data-id="element-25">
                  <X className="w-5 h-5 text-red-600 mt-1 flex-shrink-0" data-id="element-26" />
                  {item}
                </li>)}
            </ul>
          </motion.div>
        </div>

        <div className="mt-16 text-center" data-id="element-27">
          <p className="text-xl md:text-2xl font-serif italic text-charcoal/80" data-id="element-28">
            "Lo que se siente diferente desde la primera noche: No se siente
            'vamos a arreglar la relación'. Se siente como:{' '}
            <strong className="text-wine" data-id="element-29">
              'Por fin podemos acercarnos sin ponernos en riesgo.'
            </strong>
            "
          </p>
        </div>
      </div>
    </section>;
}